export var TabType;
(function (TabType) {
    TabType[TabType["Primary"] = 0] = "Primary";
    TabType[TabType["OverflowMenu"] = 1] = "OverflowMenu";
    TabType[TabType["SecondaryReadingPane"] = 2] = "SecondaryReadingPane";
    TabType[TabType["Compose"] = 3] = "Compose";
})(TabType || (TabType = {}));
//# sourceMappingURL=TabViewState.js.map